module.exports = __webpack_public_path__ + "static/media/megumin-lose.2152c35a.png";